var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import LogoProgress from "./LogoProgress";
import Box from "../box/Box";
var Overlay = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    left: 0;\n    height: 100%;\n    user-select: none;\n    z-index: 10000000;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    left: 0;\n    height: 100%;\n    user-select: none;\n    z-index: 10000000;\n"])));
var OverlayProgress = function (_a) {
    var _b = _a.bg, bg = _b === void 0 ? "rgba(255, 255, 255, 0.6)" : _b, rest = __rest(_a, ["bg"]);
    return (React.createElement(Overlay, __assign({ bg: bg }, rest, { onClick: function (e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
                e.nativeEvent.stopImmediatePropagation();
            }
        } }),
        React.createElement(LogoProgress, { showLoader: true })));
};
OverlayProgress.defaultProps = {
    width: "100%",
    position: "fixed",
};
export default OverlayProgress;
var templateObject_1;
//# sourceMappingURL=OverlayProgress.js.map